import type { FC } from "react";

import {
  FLOATING_CONTAINER_BASE_CLASS,
  FLOATING_CONTAINER_DEFAULTS,
  TFloatingContainerProps,
} from "@/ui/components/layout/FloatingContainer";
import { cn } from "@/ui/lib/utils";

export const FloatingContainer: FC<TFloatingContainerProps> = (
  {
    tag: Tag = FLOATING_CONTAINER_DEFAULTS.tag,
    "data-component": component = FLOATING_CONTAINER_DEFAULTS["data-component"],
    className,
    children,
    ...props
  },
) => (
  <Tag
    {...props}
    data-component={component}
    className={cn(
      FLOATING_CONTAINER_BASE_CLASS,
      className,
    )}
  >
    { children }
  </Tag>
);

FloatingContainer.displayName = "FloatingContainer";
